import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useLocalizedUrl } from '../utils/urlHelper';
import SeoMeta from '../components/SeoMeta';
import ContactChannels from '../components/common/ContactChannels';
import ContactRequestForm from '../components/common/ContactRequestForm';
import { PageBand } from '../components/common/B2B';

const TEXTS = {
  es: {
    title: 'Escríbanos',
    subtitle: 'Envíenos su consulta y le respondemos.',
    back: 'Volver',
    seoDescription: 'Envíenos su consulta sobre BlueCMR y le respondemos.',
  },
  en: {
    title: 'Write to us',
    subtitle: 'Send us your enquiry and we will get back to you.',
    back: 'Back',
    seoDescription: 'Send us your enquiry about BlueCMR and we will get back to you.',
  },
};

/** Formulario de contacto (vía «escríbenos» de /contacto). */
const ContactoPage = () => {
  const { i18n } = useTranslation();
  const { getLocalizedUrl } = useLocalizedUrl();
  const [searchParams] = useSearchParams();
  const lang = i18n.language === 'en' ? 'en' : 'es';
  const t = TEXTS[lang];
  const origin = searchParams.get('origin') || '';

  return (
    <div className="min-h-screen bg-white">
      <SeoMeta
        title={`${t.title} — BlueCMR`}
        description={t.seoDescription}
        canonical="https://bluecmr.com/contacto/formulario"
        alternates={{
          es: 'https://www.bluecmr.com/contacto/formulario',
          en: 'https://www.bluecmr.com/en/contact/form',
          'x-default': 'https://www.bluecmr.com/contacto/formulario'
        }}
        breadcrumbs={[
          { name: 'Inicio', url: 'https://bluecmr.com/' },
          { name: 'Contacto', url: 'https://bluecmr.com/contacto' },
          { name: 'Escríbanos', url: 'https://bluecmr.com/contacto/formulario' }
        ]}
      />

      <PageBand eyebrow={lang === 'es' ? 'Contacto' : 'Contact'} title={t.title} text={t.subtitle} />

      <section className="py-12">
        <div className="max-w-lg mx-auto px-4">
          <Link
            to={getLocalizedUrl('/contacto')}
            className="inline-flex items-center gap-1 text-sm text-gray-500 hover:text-blue-600 mb-6 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            {t.back}
          </Link>

          <ContactRequestForm kind="message" lang={lang} origin={origin} />

          <ContactChannels lang={lang} compact className="mt-10" />
        </div>
      </section>
    </div>
  );
};

export default ContactoPage;
